<div class="instant-feedback-dialog-backdrop">
  <div class="instant-feedback-dialog">
    <button class="close-btn" (click)="closeDialog()">×</button>
    <div class="dialog-header">
      <span class="wave">👋</span>
      <span class="title">{{ detail?.title }}</span>
    </div>
    <div class="dialog-question">{{ detail?.description }}</div>
    @if(detail?.image?.url){
      <div class="flex justify-center align-items-center mb-5">
        <p-image src="{{ detail?.image?.url }}" width="200px" height="200px"></p-image>
      </div>
    }
    <div class="rating-row">
      <button *ngFor="let n of ratings" [class.selected]="n === selectedRating()" (click)="selectRating(n)">
        {{ n }}
      </button>
    </div>
    <div class="rating-labels">
      <span class="awful">😞</span>
      <span class="excellent">😊</span>
    </div>
    <label *ngIf="showCounterError" style="color: red; margin-bottom: 8px; display: block"
      >La compilazione del feedback è obbligatoria!</label
    >
    <p-button class="submit-btn" [disabled]="!isSelectedRatingPopulated()" (click)="submit()">Invia feedback</p-button>
  </div>
</div>
